import { AirportSelection } from "./elements/AirportSelection/AirportSelection";
import DateSelection from "./elements/DateSelection/DateSelection";
import PassengerOptions from "./elements/PassengerOptions/PassengerOptions";

export const getSearchFormElementContentById = (id) => {
  if (id === "dest-location" || id === "src-location") {
    return AirportSelection.bind(null, { isDeparture: id === "src-location" });
  } else if (id === "end-date" || id === "start-date") {
    return DateSelection.bind(null, { isDeparture: id === "start-date" });
  } else if (id === "passengers") {
    return PassengerOptions;
  }
};
